export const _config = {
	backendUrl: 'https://api-001-310.dataintegrator.ru',
	encryptPasswordKey: 'CNpoSl0W_F'
}

export let mainApiKey = ''
export function setMainApiKey(newApiKey) {
	mainApiKey = newApiKey
}
